<template>
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        width="auto"
    >
      <v-card>
        <v-toolbar color="primary" :title="$t('shelter.removeShelter')">
        </v-toolbar>
        <v-card-text>
          {{ $t("shelter.removeQuestion", { name: name }) }}
        </v-card-text>
        <v-card-actions>
          <v-btn variant="tonal" prepend-icon="mdi-trash-can" color="primary" @click="deleteShelter">{{ $t("shelter.delete") }}</v-btn>
          <v-btn color="primary" prepend-icon="mdi-close-circle" @click="dialog = false">{{ $t("shelter.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {defineComponent} from "vue";
import {useShelterStore} from "@/stores/shelterStore";
import api from "@/services/api"
export default defineComponent({
  data() {
    return {
      dialog: false,
      id: null,
      name: null
    }
  },
  methods: {
    showDialog(id, name) {
      this.$data.id = id
      this.$data.name = name
      this.$data.dialog = true
    },
    deleteShelter() {
      if (this.$data.id) {
        //useShelterStore().deleteShelter(this.$data.id)
        api.deleteBuilding(this.$data.id)
        useShelterStore().getUserShelters();
      }
      this.$data.dialog = false
    }
  }
})
</script>
